import { render, staticRenderFns } from "./ListNevronHeader.vue?vue&type=template&id=6dbbda78&"
import script from "./ListNevronHeader.vue?vue&type=script&lang=js&"
export * from "./ListNevronHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports